export const FETCH_RESPONSES = 'FETCH_RESPONSES'
export const SET_LOADING = 'SET_LOADING'
export const FETCH_RESPONSES_SEARCH = 'FETCH_RESPONSES_SEARCH'
export const FETCH_RESPONSES_ITEMS = 'FETCH_RESPONSES_ITEMS'
export const FETCH_RESPONSE = 'FETCH_RESPONSE'
export const FETCH_RESPONSE_ITEM = 'FETCH_RESPONSE_ITEM'
